export const SET_GENERAL_SETTING = "SET_GENERAL_SETTING";
export const SET_SMS_CONFIGURATION = "SET_SMS_CONFIGURATION";
export const UPDATE_GENERAL_SETTING = "UPDATE_GENERAL_SETTING";